import React from 'react'
import { Spinner } from './Spinner'

import './Loader.scss'

const LoadingScreen: React.FunctionComponent = () => {
  return (
    <div className="Loader">
      <div className="Loader-Text">Loading</div>
      <Spinner />
    </div>
  )
}

export default LoadingScreen
